import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import Modal from "components/Modal/Modal"
import { Flex, FlexItem } from "components/Flex"
import Button from "components/Button/Button"
import { Currency } from "config/constants"
import { Grid } from "components/Grid"
import TextSection from "components/TextSection/TextSection"
import { RESERVATION_INVOICE_TEXT_LINE_BREAK_AFTER } from "models/Reservation"

interface IBulkSendToErpModalProps {
    headerText: string
    footerText: string
    totalAmount: number
    currency: Currency | null
    onClose(): void
    onConfirm(data: { headerText: string, footerText: string }): void
}

const BulkSendToErpModal: FC<IBulkSendToErpModalProps> = ({
    headerText: initHeaderText,
    footerText: initFooterText,
    totalAmount,
    currency,
    onClose,
    onConfirm,
}) => {
    const { t } = useTranslation()
    const [headerText, setHeaderText] = useState(initHeaderText)
    const [footerText, setFooterText] = useState(initFooterText)

    return (
        <Modal
            title={t('outgoingInvoices.sendToErp')}
            maxWidth="952px"
            onClose={onClose}
            footer={
                <Flex alignItems="center" justifyContent="space-between" gap="2.4rem">
                    <FlexItem className="color-grey-500">
                        {t('outgoingInvoices.amountToBeSentToErp')}: <strong>{t('common.amountWithCurrency', {
                            count: totalAmount,
                            currency,
                        })}</strong>
                    </FlexItem>
                    <Flex alignItems="center" justifyContent="flex-end" gap="2.4rem">
                        <Button
                            theme="secondary"
                            label={t('common.cancel')}
                            onClick={onClose}
                        />
                        <Button
                            label={t('outgoingInvoices.sendToErp')}
                            onClick={() => onConfirm({ headerText, footerText })}
                        />
                    </Flex>
                </Flex>
            }>
            <Grid columns="minmax(0, 1fr) minmax(0, 1fr)" gap="2.4rem">
                <TextSection
                    title={t('reservation.headerSection')}
                    popupTitle={t('reservation.headerSection')}
                    text={headerText ?? ""}
                    onChange={setHeaderText}
                    formattingRuleLabel={t("textModal.lineBreakAfter", { lineBreakAfter: RESERVATION_INVOICE_TEXT_LINE_BREAK_AFTER })}
                    lineBreakAfter={RESERVATION_INVOICE_TEXT_LINE_BREAK_AFTER}
                    textVariables
                    monospace
                />
                <TextSection
                    title={t('reservation.footerSection')}
                    popupTitle={t('reservation.footerSection')}
                    text={footerText ?? ""}
                    onChange={setFooterText}
                    formattingRuleLabel={t("textModal.lineBreakAfter", { lineBreakAfter: RESERVATION_INVOICE_TEXT_LINE_BREAK_AFTER })}
                    lineBreakAfter={RESERVATION_INVOICE_TEXT_LINE_BREAK_AFTER}
                    textVariables
                    monospace
                />
            </Grid>
        </Modal>
    )
}

export default BulkSendToErpModal
